import React, { Component } from "react"
import { List, Icon } from "semantic-ui-react"
import { NamespacesConsumer as I18n } from "react-i18next"
import "../css/Footer_area.css"

//component
import { notilogin } from "../containers/Function/Notification.function"
import { sizeofwindows } from "../containers/Function/App.function"
import ContactUs from "./ContactUs"
import DialogVideo from "./DialogVideo"
import Social from "./Social"
import SubscribeModal from "./SubscribeModal"

class Footer_area extends Component {
	constructor(props) {
		super(props)
		this.state = {
			OpenDialogContactUs: false,
			hideNav: false,
			mobile: false,
			open: false,
			OpenDialogSubscribe: false
		}
	}
	componentDidMount() {
		window.addEventListener("resize", this.resize.bind(this))
		this.resize()
	}
	resize() {
		this.setState({ hideNav: sizeofwindows("md") })
		this.setState({ mobile: sizeofwindows("sm") })
	}
	handleClickOpenContactUs = (e) => {
		this.setState({ OpenDialogContactUs: true })
	}

	handleDialogCloseContactUs = () => {
		this.setState({ OpenDialogContactUs: false })
	}
	handleClose = () => {
		this.setState({ open: false })
	}
	handleClickOpen = () => {
		this.setState({ open: true })
	}

	handleDialogSubscribe = () => {
		this.setState({ OpenDialogSubscribe: !this.state.OpenDialogSubscribe })
	}
	render() {
		let {
			OpenDialogContactUs,
			hideNav,
			open,
			mobile,
			OpenDialogSubscribe
		} = this.state
		const { user } = this.props
		return (
			<I18n>
				{(t) => {
					return (
						<footer className="footer_area ">
							<ContactUs
								Open={OpenDialogContactUs}
								handleDialogClose={this.handleDialogCloseContactUs}
							/>
							<div className="container ">
								<div className="row footer_inner">
									<div
										className="col-lg-2 col-md-3 col-sm-12"
										style={{
											textAlign: "center",
											paddingRight: hideNav === false && 45
										}}
									>
										<aside className="f_widget social_widget">
											<div className="f_title">
												<h3
													onClick={this.handleDialogSubscribe}
													style={{ cursor: "pointer" }}
												>
													{t("Subscription.Subscribeuslogo")}
												</h3>
											</div>
											<p
												onClick={this.handleDialogSubscribe}
												style={{ cursor: "pointer" }}
											>
												<img
													src="/MMA Logo Guide-04.png"
													width="70px"
													height="70px"
													alt="logo2"
												/>
											</p>
											<h4>
												Copyright © 2018 <br /> Biosci (Thailand) Co., Ltd.
												<br />
												All right reserved.
											</h4>
										</aside>
									</div>
									<div
										className="col-lg-3 col-md-4 col-sm-12"
										style={{
											display: hideNav && "flex",
											justifyContent: hideNav && "center",
											marginTop: mobile && 20,
											padding: 0
										}}
									>
										<aside
											className={
												hideNav === false
													? "f_widget ab_widget"
													: "f_widget news_widget"
											}
										>
											<div className="f_title">
												<h3>{t("Home.HomeABOUTBiosci")}</h3>
											</div>

											<List className="p">
												<List.Item>
													<Icon name="caret right" />
													<List.Content>
														<List.Header>
															<a
																aria-label="About"
																href="http://www.biosci.global/company-en/#about-us-scroll-link"
																target="_blank"
																rel="noopener noreferrer"
															>
																{t("Home.Aboutus")}
															</a>
														</List.Header>
													</List.Content>
												</List.Item>
												<List.Item>
													<Icon name="caret right" />
													<List.Content>
														<a
															aria-label="Application"
															href="https://www.vsni.co.uk/case-studies"
															target="_blank"
															rel="noopener noreferrer"
														>
															<List.Header>
																{t("Home.Applicationareas")}
															</List.Header>
														</a>
													</List.Content>
												</List.Item>
												<List.Item>
													<Icon name="caret right" />
													<List.Content>
														<a
															aria-label="Legal"
															href="http://www.biosci.global/legal-information/"
															target="_blank"
															rel="noopener noreferrer"
														>
															<List.Header>{t("Home.Legal")}</List.Header>
														</a>
													</List.Content>
												</List.Item>
												<List.Item>
													<Icon name="caret right" />
													<List.Content>
														<List.Header>
															<a
																aria-label="Legal"
																href="/TermsandPrivacypolicy"
																target="_blank"
																rel="noopener noreferrer"
															>
																{t("Home.TermPrivacyPolicy")}
															</a>
														</List.Header>
													</List.Content>
												</List.Item>
												<List.Item>
													<Icon name="caret right" />
													<List.Content>
														<List.Header>
															<span
																onClick={this.handleDialogSubscribe}
																style={{ cursor: "pointer" }}
															>
																{t("Subscription.Subscribeuslogo")}
															</span>
														</List.Header>
													</List.Content>
												</List.Item>
											</List>
										</aside>
									</div>
									{hideNav === false ? (
										<div className="col-lg-7 col-md-7 col-sm-12">
											<div className="col-lg-6 col-md-6 col-sm-12 _left">
												<aside className="f_widget news_widget">
													<div className="f_title">
														<h3>{t("Home.HomeSupport")}</h3>
													</div>

													<List className="p">
														<List.Item>
															<Icon name="caret right" />
															<List.Content>
																<List.Header>
																	<span
																		style={{
																			cursor: "pointer"
																		}}
																		onClick={() => this.handleClickOpen()}
																	>
																		{t("Home.Getting")}
																	</span>
																</List.Header>
															</List.Content>
														</List.Item>
														<List.Item>
															<Icon name="caret right" />
															<List.Content>
																<List.Header>
																	<span
																		style={{ cursor: "pointer" }}
																		onClick={(e) =>
																			Object.keys(user).length === 0
																				? notilogin(t)
																				: this.handleClickOpenContactUs(e, t)
																		}
																	>
																		{t("Home.Contactsupport")}
																	</span>
																</List.Header>
															</List.Content>
														</List.Item>
														<List.Item>
															<Icon name="caret right" />
															<List.Content>
																<List.Header>
																	<a
																		aria-label="Document"
																		href="/Document/How-to-Create-a-Project-in-MMA/1"
																		target="_blank"
																		rel="noopener noreferrer"
																	>
																		{t("Menu.Document")}
																	</a>
																</List.Header>
															</List.Content>
														</List.Item>
													</List>
													<Social />
												</aside>
											</div>
											<div className="col-lg-6 col-md-6 col-sm-12 _right">
												<aside className="f_widget news_widget">
													<div className="f_title1" />
													<List className="p">
														<List.Item>
															<Icon name="caret right" />
															<List.Content>
																<List.Header>
																	<a
																		aria-label="HomeOnlineTraining"
																		href="http://www.biosci.global/training-en/"
																		target="_blank"
																		rel="noopener noreferrer"
																	>
																		{t("Home.HomeOnlineTraining")}
																	</a>
																</List.Header>
															</List.Content>
														</List.Item>
														<List.Item>
															<Icon name="caret right" />
															<List.Content>
																<List.Header>
																	<a
																		aria-label="HomeDataAnalysisService"
																		href="http://www.biosci.global/consultancy-en/"
																		target="_blank"
																		rel="noopener noreferrer"
																	>
																		{t("Home.HomeDataAnalysisService")}
																	</a>
																</List.Header>
															</List.Content>
														</List.Item>
													</List>
												</aside>
											</div>
										</div>
									) : (
										<div
											className="col-lg-7 col-md-5 col-sm-12"
											style={{
												marginBottom: "20%",
												display: hideNav && "flex",
												justifyContent: hideNav && "center",
												marginTop: mobile && 20
											}}
										>
											<div>
												<aside className="f_widget news_widget">
													<div className="f_title">
														<h3>{t("Home.HomeSupport")}</h3>
													</div>

													<List className="p">
														<List.Item>
															<Icon name="caret right" />
															<List.Content>
																<List.Header>
																	<span
																		style={{
																			cursor: "pointer"
																		}}
																		onClick={() => this.handleClickOpen()}
																	>
																		{t("Home.Getting")}
																	</span>
																</List.Header>
															</List.Content>
														</List.Item>
														<List.Item>
															<Icon name="caret right" />
															<List.Content>
																<List.Header>
																	<span
																		style={{
																			cursor: "pointer",
																			fontSize:
																				"calc(10px + 0.2vmin) !important"
																		}}
																		onClick={(e) =>
																			Object.keys(user).length === 0
																				? notilogin(t)
																				: this.props.history.push("/Contactus")
																		}
																	>
																		{t("Home.Contactsupport")}
																	</span>
																</List.Header>
															</List.Content>
														</List.Item>
														<List.Item>
															<Icon name="caret right" />
															<List.Content>
																<List.Header>
																	<a
																		aria-label="HomeOnlineTraining"
																		href="http://www.biosci.global/training-en/"
																		target="_blank"
																		rel="noopener noreferrer"
																	>
																		{t("Home.HomeOnlineTraining")}
																	</a>
																</List.Header>
															</List.Content>
														</List.Item>
														<List.Item>
															<Icon name="caret right" />
															<List.Content>
																<List.Header>
																	<a
																		aria-label="HomeDataAnalysisService"
																		href="http://www.biosci.global/consultancy-en/"
																		target="_blank"
																		rel="noopener noreferrer"
																	>
																		{t("Home.HomeDataAnalysisService")}
																	</a>
																</List.Header>
															</List.Content>
														</List.Item>
														<List.Item>
															<Icon name="caret right" />
															<List.Content>
																<List.Header>
																	<a
																		aria-label="Document"
																		href="/Document/How-to-Create-a-Project-in-MMA/1"
																		target="_blank"
																		rel="noopener noreferrer"
																	>
																		{t("Menu.Document")}
																	</a>
																</List.Header>
															</List.Content>
														</List.Item>
													</List>
												</aside>
											</div>
										</div>
									)}
								</div>
							</div>
							<DialogVideo
								open={open}
								handleClose={this.handleClose}
								link="https://www.youtube.com/embed/BrbfCJpiLr0?autoplay=1"
							/>
							<SubscribeModal
								OpenDialogSubscribe={OpenDialogSubscribe}
								t={t}
								handleDialogCloseSubscribe={this.handleDialogSubscribe}
							/>
						</footer>
					)
				}}
			</I18n>
		)
	}
}
export default Footer_area
